import { useState } from 'react'
import CollapsibleContainer from './CollapsibleContainer'
import ExpandToggleButton from '../../widgets/shared/ExpandToggleButton'

const ExpandableContainer = ({ 
    title, 
    children, 
    leftContent, 
    centerContent, 
    rightContent,
    showToggle = true,
    boxStyle = {}
}) => {
    const [isExpanded, setIsExpanded] = useState(false)

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev)
    }

    const tooltipId = `expand-toggle-${title?.replace(/\s+/g, '-').toLowerCase() || 'container'}`

    return (
        <CollapsibleContainer title={title} expanded={false}>
            <div className="content">
                <div className="box" style={{ maxHeight: `inherit`, ...boxStyle }}>
                    {children}
                    {showToggle && (
                        <>
                            <ExpandToggleButton 
                                isExpanded={isExpanded} 
                                onToggle={toggleExpanded} 
                                tooltipId={tooltipId}
                            />
                        </>
                    )}

                    <div className="columns" style={{ maxHeight: `inherit` }}>
                        {!isExpanded && (
                            <>
                                <div className="column is-5">
                                    {leftContent}
                                </div>
                                <div className="column is-2" style={{ alignSelf: `center` }}>
                                    {centerContent}
                                </div>
                            </>
                        )}
                        <div className={`column ${isExpanded ? 'is-12' : 'is-5'}`}> 
                            {rightContent}
                        </div>
                    </div>
                </div>
            </div>
        </CollapsibleContainer>
    )
}

export default ExpandableContainer